import fetch from 'services/request';
const authApis = {
  login: (credentials: { userName: string; password: string }) =>
    fetch({
      method: 'post',
      url: '/api/v1/auth/login',
      body: credentials,
    }),
  totalStation: (shopId: string) =>
    fetch({
      method: 'get',
      url: '/api/v1/device/total-station',
      shopId,
    }),
  getAllDevices: (shopId: string) =>
    fetch({
      method: 'get',
      url: '/api/v1/device/all',
      shopId,
    }),
  addPOSDevice: (deviceId: string, stationNumber: number, deviceType: string) =>
    fetch({
      method: 'post',
      url: '/api/v1/device',
      body: { deviceId, stationNumber, deviceType },
    }),
  refreshToken: (refreshToken: string) =>
    fetch({
      method: 'post',
      url: '/api/v1/auth/refresh-token',
      body: { refreshToken },
    }),
};

export default authApis;
